export default __webpack_public_path__ + "static/media/pantry1-afterI-768w.604e2a52.avif";